<template>
    <div class="div-detail" v-resize="onResize">
        <v-card class="standard-row external-card-detail">
            <v-row class="standard-row d-flex justify-space-between">
                <!------------------------------------ select business ------------------------------------>
                <div class="mr-0" :style="(windowSize.x >= 1050 ? 'width:50%; margin-right:0;' : 'width:100%; margin-right:3%;')">
                    <v-row class="standard-row">
                        <v-row justify="center" class="standard-row mx-md-10 mt-md-8 mx-7 mt-7">
                            <v-text-field dense outlined hide-details color="black" height="58px" v-model="keywordBusiness" class="font-theme custom-detail-textfield" @keyup.enter="searchBusiness(keywordBusiness)" @input="!keywordBusiness ? searchBusiness(keywordBusiness): ''">
                                <template v-slot:append>
                                    <v-btn icon class="magnifying-glass-icon" @click="searchBusiness(keywordBusiness)">
                                        <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M10.881 20.7619C16.338 20.7619 20.7619 16.3381 20.7619 10.881C20.7619 5.42385 16.338 1 10.881 1C5.42385 1 1 5.42385 1 10.881C1 16.3381 5.42385 20.7619 10.881 20.7619Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path d="M28.6668 28.6668L18.0606 18.0606M14.8335 10.8811H6.92871H14.8335ZM10.8811 14.8335V6.92871V14.8335Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                        </svg>
                                    </v-btn>
                                </template>
                            </v-text-field>
                        </v-row>
                        <v-card elevation="0" class="standard-row mx-md-10 mt-md-5 mx-5 mt-5 height-selected-biz" style="background-color: transparent;">
                            <v-row v-show="((index + 1) > offsetBiz) && (index + 1 <= (offsetBiz + 10))" v-for="(business, index) in allBusiness" :key="`key${business.company_code}${index}`" no-gutters class="mt-md-5 mt-5 standard-row font-theme hoover-list-biz font-biz-detail" @click="selectedBiz = business">
                                <div style="width: 20%">
                                    {{ business.company_code }}
                                </div>
                                <div style="width: 80%">
                                    {{ business.company_full_name }}
                                </div>
                            </v-row>
                        </v-card>
                        <v-row class="standard-row mt-8 ml-10 mr-5 mb-5 d-flex justify-end align-self-end">
                            <v-btn icon class="mr-2" @click="offsetBiz > 0? offsetBiz -= 10: ''">
                                <svg width="44" height="41" viewBox="0 0 44 41" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M22 40C33.598 40 43 31.2696 43 20.5C43 9.73045 33.598 1 22 1C10.402 1 1 9.73045 1 20.5C1 31.2696 10.402 40 22 40Z" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M24.7563 27.5687L16.8813 20.5L24.7563 13.1875" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                            </v-btn>
                            <v-btn icon class="ml-2" @click="(allBusiness.length - 1) - offsetBiz > 10? offsetBiz += 10: ''">
                                <svg width="44" height="41" viewBox="0 0 44 41" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M22 40C33.598 40 43 31.2696 43 20.5C43 9.73045 33.598 1 22 1C10.402 1 1 9.73045 1 20.5C1 31.2696 10.402 40 22 40Z" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M19.3748 27.8125L27.2498 20.5L19.1963 13.1875" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                            </v-btn>
                        </v-row>
                    </v-row>
                </div>
                <!------------------------------------ detail business ------------------------------------>
                <div v-if="Object.keys(selectedBiz).length" style="font-weight: 700;"  class="font-theme fade-left-to-right" :class="(windowSize.x >= 1050 ? 'detail-biz-card' : 'detail-biz-mobile-card')">
                    <v-row no-gutters class="standard-row mt-8 px-6 d-flex justify-space-between font-biz-detail">
                        <div class="bg-color-biz-detail" style="width: 18%; display: flex; justify-content: center; align-items: center;">
                            {{ selectedBiz.company_code }}
                        </div>
                        <div class="bg-color-biz-detail px-4" style="width: 75%; display: flex; align-items: center;">
                            {{ selectedBiz.company_full_name }}
                        </div>
                    </v-row>
                    <v-row no-gutters class="standard-row mt-8 px-6 font-biz-detail">
                        <v-col cols="12" md="12" lg="12" class="text-container-biz-detail pa-5">
                            ทุกรายการที่ดำเนินการจะเป็นเอกสารของ<br>{{ selectedBiz.company_full_name }}<br>กดยืนยันเพื่อดำเนินการถัดไป
                        </v-col>
                    </v-row>
                    <v-row no-gutters class="standard-row my-6 px-6 d-flex" :class="confirmBiz.company_code == selectedBiz.company_code? 'justify-space-between': 'd-flex justify-end'">
                        <v-btn v-show="Object.keys(confirmBiz).length && confirmBiz.company_code === selectedBiz.company_code" depressed height="47px" color="#E08D8D" class="font-theme cancel-success-btn" @click="changeSelectedBiz()"> ยกเลิกการเลือก </v-btn>
                        <v-btn v-show="confirmBiz.company_code != selectedBiz.company_code" depressed height="47px" color="#0B68D6" class="font-theme detail-biz-font white--text" @click="changeSelectedBiz(selectedBiz)"> ยืนยัน </v-btn>
                        <div v-show="Object.keys(confirmBiz).length && confirmBiz.company_code === selectedBiz.company_code" class="font-theme cancel-success-btn div-success-selected-biz text-center">
                            <p class="mb-0 d-flex align-center text-center justify-center" style="height: 100%"> สำเร็จ </p>
                        </div>
                    </v-row>
                </div>
            </v-row>
        </v-card>
    </div>
</template>

<script>
import { EventBus } from '../EventBus'
    export default {
        data: () => ({
            windowSize: { x: 0, y: 0 },
            allBusiness: [],
            tempAllBusiness: [],
            selectedBiz: {},
            callApiPending: 0,
            keywordBusiness: '',
            offsetBiz: 0
        }),
        mounted () {
            this.onResize()
            this.getBusiness()
        },
        computed: {
            confirmBiz () {
                return this.$store.state.confirmSelectedBiz
            },
            setGetBudgetType () {
                return this.$store.state.budgetType
            },
            raDetail() {
            return this.$store.state.raDetail
            }
        },
        watch: {
            "callApiPending"(val) {
                if (val > 0) {
                    EventBus.$emit('loadingState', true)
                } else {
                    EventBus.$emit('loadingState', false)
                }
            }
        },
        methods: {
            onResize() {
                this.windowSize = { x: window.innerWidth, y: window.innerHeight }
            },
            async getBusiness() {
                try {
                    this.callApiPending++
                    this.allBusiness = []
                    this.tempAllBusiness = []
                    const { data } = await this.axios.get(`${this.$api_url}/citizen/api/v1/get_business`)
                    if (data.status && data.data.length) {
                        for (let i = 0; i < data.data.length; i++) {
                            data.data[i].company_full_name = `บริษัท ${data.data[i].company_name} จำกัด`
                            if (data.data[i].title_name === "บมจ.") {
                                data.data[i].company_full_name += ` (มหาชน)`
                            }
                            this.allBusiness.push(data.data[i])
                        }
                        this.allBusiness = this.allBusiness.filter(function({ tax_id }) {
                            return !this.has(tax_id) && this.add(tax_id)
                        }, new Set);
                        if (Object.keys(this.confirmBiz).length) {
                            this.selectedBiz = this.confirmBiz
                        }
                        this.tempAllBusiness = [...this.allBusiness]
                    }
                } catch (error) {
                    console.log(error)
                } finally {
                    this.callApiPending--
                }
            },
            searchBusiness(keyword) {
                if (!keyword) {
                    this.allBusiness = [...this.tempAllBusiness]
                    return
                }
                const tempBiz = this.tempAllBusiness.filter(e => {
                    const company_code = e.company_code.replace(/ /g, "");
                    const company_full_name = e.company_full_name.replace(/ /g, "");
                    return company_code.includes(keyword.replace(/ /g, "")) || company_full_name.includes(keyword.replace(/ /g, ""))
                })
                this.offsetBiz = 0
                this.allBusiness = [...tempBiz]
            },
            // changeSelectedBiz(biz = {}) {
            //     if (Object.keys(biz).length) {
            //         this.alert('เลือกธุรกิจสำเร็จ', 'Success', 'success')
            //     } else {
            //         this.alert('ยกเลิกธุรกิจสำเร็จ', 'Success', 'success')
            //     }
            //     this.$store.commit('setConfirmSelectedBiz', biz)
            // },
            async changeSelectedBiz(biz = {}) {
                if (Object.keys(biz).length) {
                    this.callApiPending++
                    try {
                        const { data } = await this.axios.get(`${this.$api_url}/permission/api/v1/inbox_permission?tax_id=${biz.tax_id}`)
                        if (data.status && data.data.length) {
                            this.getBudgetType()
                            this.getPermission()
                            this.getPermissionBtnEditMode()
                            this.getGroupAccountIdCreatePurchase()
                            this.getPermissionSummary()
                            this.getPermissionGLAccount()
                            const pettyCashPermission = await this.axios.get(`${this.$api_url}/petty_cash/api/v1/check_permission_petty_cash?tax_id=${biz.tax_id}`)
                            this.$store.commit('setPettyCashPermission', pettyCashPermission.data.data.has_permission)
                            this.$store.commit('setPettyCashPermissionTab', pettyCashPermission.data.data.permission)
                            this.alert('เลือกธุรกิจสำเร็จ', 'Success', 'success')
                            this.$store.commit('setPermissionInbox', data.data)
                        } else {
                            this.alert(`เกิดข้อผิดพลาด`, 'Fail', 'error')
                            this.$store.commit('setPermissionInbox', [])
                            this.$store.commit('setPettyCashPermission', [])
                            this.$store.commit('setPettyCashPermissionTab', null)
                        }
                    } catch (error) {
                        this.alert(`เกิดข้อผิดพลาด`, 'Fail', 'error')
                        this.$store.commit('setPermissionInbox', [])
                        this.$store.commit('setPettyCashPermission', [])
                        this.$store.commit('setPettyCashPermissionTab', null)
                        console.log(error)
                    } finally {
                        this.callApiPending--
                    }
                } else {
                    this.$store.commit('setPermissionEval', )
                    this.$store.commit('setPermissionInbox', [])
                    this.$store.commit('setPettyCashPermission', [])
                    this.$store.commit('setPettyCashPermissionTab', null)
                    this.alert('ยกเลิกธุรกิจสำเร็จ', 'Success', 'success')
                }
                this.$store.commit('setConfirmSelectedBiz', biz)
            },
            async getBudgetType(){
                try {
                    this.callApiPending++
                    const { data } = await this.axios.get(`${this.$api_url}/budget_type/api/v1/get_budget_type?tax_id=${this.selectedBiz.tax_id}`)
                    this.get_budget_type = data.data
                    this.$store.commit('setGetBudgetType', this.get_budget_type.type_list) 
                } catch (error) {
                    console.log(error)
                } finally {
                    this.callApiPending--
                }
            },
            async getPermission() {
                try {
                    this.callApiPending++;
                    const response = await this.axios({
                        baseURL: this.$api_url,
                        url: `/saler_score/api/v1/check_permission_eval_vendor`,
                        method: 'GET'
                    });
                    this.permissionEval = response.data.data.permission_eval.map(e => e.inbox)
                    this.$store.commit('setPermissionEval', this.permissionEval)
                } catch (error) {
                    console.error(error);
                    this.totalPo = [];
                } finally {
                    this.callApiPending--;
                    if (!this.callApiPending) this.isReady = true;
                }
            },
            async getPermissionGLAccount() {
                try {
                    this.callApiPending++;
                    const response = await this.axios({
                        baseURL: this.$api_url,
                        url: `/gl_account/api/v1/permission_gl?account_id=${this.raDetail.account_id}&tax_id=${this.selectedBiz.tax_id}`,
                        method: 'GET'
                    });
                    this.permissionGlAccount = response.data.data.permission
                    this.$store.commit('setPermissionGlAccount', this.permissionGlAccount)
                } catch (error) {
                    console.error(error);
                    this.totalPo = [];
                } finally {
                    this.callApiPending--;
                    if (!this.callApiPending) this.isReady = true;
                }
            },
            async getPermissionBtnEditMode() {
            this.callApiPending++;
                try {
                    const { data } = await this.axios.get(
                    `${this.$api_url}/item_erp/api/v1/permission_edit_vendor_item?account_id=${this.raDetail.account_id}`
                    );

                    if (data.status) {
                        this.permissionBtnEditMode = data.data.permission;
                        this.$store.commit('setPermissionBtnEditMode', this.permissionBtnEditMode);
                    }
                } catch (error) {
                    console.error(error);
                    this.alert('กรุณาลองใหม่อีกครั้ง', 'Fail', 'error');
                } finally {
                    this.callApiPending--;
                }
            },
            async getGroupAccountIdCreatePurchase() {
                this.callApiPending++;
                try {
                    const { data } = await this.axios.get(
                    `${this.$api_url}/permission_buyer/api/v1/get_permission_buyer?account_id=${this.raDetail.account_id}`
                    );

                    if (data.status) {
                        this.GroupAccountIdCreatePurchase = data.data.permission;
                        this.$store.commit('setGroupAccountIdCreatePurchase', this.GroupAccountIdCreatePurchase);
                    }
                } catch (error) {
                    console.error(error);
                    this.alert('กรุณาลองใหม่อีกครั้ง', 'Fail', 'error');
                } finally {
                    this.callApiPending--;
                }
            },
            async getPermissionSummary() {
                this.callApiPending++;
                try {
                    const { data } = await this.axios.get(
                    `${this.$api_url}/summary_finance/api/v1/permission_finance?account_id=${this.raDetail.account_id}&tax_id=${this.selectedBiz.tax_id}`
                    );

                    if (data.status) {
                        this.permissionSummary = data.data.has_permission;
                        this.$store.commit('setPermissionSummary', this.permissionSummary);
                    }
                } catch (error) {
                    console.error(error);
                    this.alert('กรุณาลองใหม่อีกครั้ง', 'Fail', 'error');
                } finally {
                    this.callApiPending--;
                }
            },
            alert(title = '', text = '', icon = 'info') {
                this.$swal({
                    toast: true,
                    position: "top-end",
                    showConfirmButton: false,
                    timer: 3000,
                    icon: icon,
                    title: `<b class="alert-success-title">${title}</b>`,
                    text:  text,
                    showClass: {
                        popup: 'animate-show-card'
                    },
                    customClass: {
                        container: 'alert-card-block',
                        popup: 'alert-card-success',
                        title: 'alert-title-block',
                        htmlContainer: 'alert-text-box',
                        icon: 'alert-icon'
                    }
                })
            }
        },
    }
</script>

<style scoped>

    .div-detail {
        margin: 60px 92px 50px 92px;
    }

    .external-card-detail {
        height: 100%;
        border-radius: 23px !important;
        box-shadow: 0px 4px 50px rgba(0, 0, 0, 0.25) !important;
        background-color: #F1F1F1;
    }

    .detail-biz-card {
        width: 40%;
        margin-top: 31px;
        margin-right: 3%;
        margin-bottom: 3%;
        background-color: #FFFFFF;
        height: 100%;
        border-radius: 20px;
        border: 1px solid #000000;
    }

    .detail-biz-mobile-card {
        margin: 3% 3% 3% 3%;
        background-color: rgba(255, 255, 255, 0.5);
        height: 100%;
        border-radius: 10px;
        max-height: 677px;
        width: 100%;
    }

    .custom-detail-textfield {
        font-size: 20px !important;
        background-color: rgba(255, 255, 255, 0.5);
        border-radius: 10px;
    }

    .magnifying-glass-icon {
        background-color: #0B68D6;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 50px;
        width: 50px;
        border-radius: 10px;
        margin-top: 4px;
        margin-right: -8px;
    }

    .bg-color-biz-detail {
        background-color: #D6D6D6;
        border-radius: 10px;
        min-height: 58px;
        font-weight: 700;
    }

    .text-container-biz-detail {
        width: 100%;
        height: auto;
        overflow-y: auto;
        line-height: 24px;
        max-height: 458px !important;
        min-height: calc(100vh - 575px);
        background-color: #D6D6D6;
        border-radius: 10px;
        font-weight: 400;
    }

    .detail-biz-font {
        font-weight: 700;
        font-size: 24px;
        color: #0A0A0A;
        border-radius: 10px;
        letter-spacing: 1px;
    }

    .cancel-success-btn {
        font-weight: 700;
        font-size: 15px;
        color: #0A0A0A;
        border-radius: 10px;
        letter-spacing: 1px;
    }

    .custom-detail-textfield.v-text-field--outlined >>> fieldset {
        border: 1px solid #000000;
    }

    .div-success-selected-biz {
        height: 47px;
        background-color: #76BA6B;
        min-width: 95px !important;
    }

    .hoover-list-biz {
        font-weight: 400;
        cursor: pointer;
    }

    .font-biz-detail {
        font-size: 20px;
    }

    .hoover-list-biz:hover {
        background-color: rgba(255, 255, 255, 0.5);
    }

    .height-selected-biz {
        min-height: calc(100vh - 210px);
    }

    .fade-left-to-right {
        opacity: 0;
        transform: translateX(-20px);
        animation: fadeLeftToRight 0.7s ease-out forwards;
    }

    @keyframes fadeLeftToRight {
        from {
            opacity: 0;
            transform: translateX(-20px);
        }
        to {
            opacity: 1;
            transform: translateX(0);
        }
    }

    @media only screen and (max-width: 780px) { /*css for mobile screen*/
        .div-detail {
            margin: 30px 7% 7% 7%;
            height: unset;
        }
    }

    @media only screen and (max-width: 1048px) {
        .text-container-biz-detail {
            min-height: calc(100vh - 534px);
        }

        .height-selected-biz {
            min-height: calc(100vh - 251px);
            max-height: 360px;
            overflow-y: auto;
        }
    }

    @media only screen and (max-width: 600px) { /*css for mobile screen*/
        .font-biz-detail {
            font-size: 18px !important;
        }

        .height-selected-biz {
            min-height: calc(100vh - 307px);
            overflow-y: auto;
        }
    }
</style>
